module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "fullscreen": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "elevation-2"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "headline"
  }, [_vm._v("Audience Data")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.influencer == null || !_vm.influencer.success) ? _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h2', {
    staticClass: "text-center",
    staticStyle: {
      "color": "rgba(0,0,0,.38)"
    }
  }, [_vm._v("Empty data")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text ml-0",
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.refreshReport
    }
  }, [_vm._v("\n                  Refresh\n                  "), _c('v-icon', {
    attrs: {
      "float-right": "",
      "dark": ""
    }
  }, [_vm._v("refresh")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.influencer != null && _vm.influencer.success) ? _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [(_vm.influencer && _vm.influencer.success) ? _c('div', [_c('h5', [_vm._v("Created: " + _vm._s(_vm.influencer ? _vm.reportCreatedAt : ''))]), _vm._v(" "), _c('h5', [_vm._v("Version: " + _vm._s(_vm.influencer ? _vm.influencer.version : ''))])]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text ml-0",
    attrs: {
      "color": "blue-grey"
    },
    on: {
      "click": _vm.downloadPdf
    }
  }, [_vm._v("\n                    Download\n                    "), _c('v-icon', {
    attrs: {
      "float-right": "",
      "dark": ""
    }
  }, [_vm._v("save_alt")])], 1)], 1)])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "12",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('center', {
    staticClass: "m-t-30"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.paserImageUrl(_vm.influencerProfile.picture),
      "width": "150"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "card-title m-t-10"
  }, [_vm._v(_vm._s(_vm.influencerProfile.fullname))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.influencerProfile.url,
      "target": "_blank"
    }
  }, [_c('h3', [_vm._v("@" + _vm._s(_vm.influencerProfile.username))])]), _vm._v(" "), (_vm.influencerProfile.is_business) ? _c('h4', {
    staticClass: "card-subtitle"
  }, [_vm._v("Business Account")]) : _vm._e(), _vm._v(" "), (!_vm.influencerProfile.is_business) ? _c('h6', {
    staticClass: "card-subtitle"
  }, [_vm._v("Personal Account")]) : _vm._e()])], 1)])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card border p-1"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('p', {
    staticClass: "card-title",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Followers")]), _vm._v(" "), _c('span', {
    staticClass: "card-title",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.influencerProfile.followers))]), _vm._v(" "), (_vm.followingStat) ? _c('span', {
    class: 'text stat-label ng-star-inserted ' + 'stat-label--' + _vm.followingStat.type,
    attrs: {
      "_ngcontent-c16": ""
    }
  }, [_c('span', {
    attrs: {
      "_ngcontent-c16": ""
    }
  }, [_vm._v(_vm._s(_vm.followingStat.rate) + "%")])]) : _vm._e()])])])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card border p-1"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('p', {
    staticClass: "card-title mb-0",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Location")]), _vm._v(" "), _c('h2', {
    staticClass: "card-title mt-0"
  }, [_vm._v(_vm._s(_vm.audienceFollowers.audience_geo.countries ? (_vm.audienceFollowers.audience_geo.countries.length ? _vm.audienceFollowers.audience_geo.countries[0].name : '---') : '---'))])])])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card border p-1"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h2', {
    staticClass: "card-title"
  }, [_vm._v("\n                    " + _vm._s(_vm.influencerProfile.engagements) + "\n                    "), _c('small', [_vm._v("engagements")])])])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h2', {
    staticClass: "card-title"
  }, [_vm._v("\n                    " + _vm._s(_vm.influencerProfile.avg_likes) + "\n                    "), _c('small', [_vm._v("Avg Likes")])])])])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h2', {
    staticClass: "card-title"
  }, [_vm._v("\n                    " + _vm._s(_vm.influencerProfile.avg_comments) + "\n                    "), _c('small', [_vm._v("Avg Comments")])])])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('line-chart', {
    attrs: {
      "chart-data": _vm.datacollection
    }
  })], 1)])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('line-chart', {
    attrs: {
      "chart-data": _vm.avgLikes
    }
  })], 1)])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('line-chart', {
    attrs: {
      "chart-data": _vm.followingData
    }
  })], 1)])])], 1), _vm._v(" "), _c('v-row', [(_vm.wordCloud && _vm.wordCloud.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center",
    staticStyle: {
      "height": "350px"
    }
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Social Cloud")]), _vm._v(" "), _c('vue-word-cloud', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "v-show": true,
      "words": _vm.wordCloud,
      "color": function (ref) { return _vm.getRandomColor(); },
      "font-family": "Roboto"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-row', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Popular @")]), _vm._v(" "), _vm._l((_vm.influencerProfile.top_mentions.slice(0, 10)), function(mention) {
    return _c('v-chip', {
      key: mention.tag,
      attrs: {
        "color": "#eff4fa",
        "text-color": "#4a4a4a"
      }
    }, [_vm._v("@" + _vm._s(mention.tag))])
  })], 2)])]), _vm._v(" "), _c('v-row', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Popular #")]), _vm._v(" "), _vm._l((_vm.influencerProfile.top_hashtags.slice(0, 10)), function(hashtag) {
    return _c('v-chip', {
      key: hashtag.tag,
      attrs: {
        "color": "#eff4fa",
        "text-color": "#4a4a4a"
      }
    }, [_vm._v("#" + _vm._s(hashtag.tag))])
  })], 2)])])], 1)], 1), _vm._v(" "), (_vm.influencer.audience_followers.success) ? _c('v-row', [_c('v-col', [_c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Audience Data")])])], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.audience_followers.success) ? _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('v-row', [_c('v-col', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Followers Credibility")]), _vm._v(" "), _c('h3', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.getCredibilityColor(_vm.audienceFollowers.audience_credibility)
    }
  }, [_vm._v("supervised_user_circle")])], 1)])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Notable Followers")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.toPercent(_vm.audienceFollowers.notable_users_ratio)) + "%")])])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Age Split")]), _vm._v(" "), _c('bar-chart', {
    attrs: {
      "options": _vm.barChartOptions,
      "chart-data": _vm.audienceFollowersGenderPerAge
    }
  })], 1)])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Gender Split")]), _vm._v(" "), _c('circle-chart', {
    attrs: {
      "chart-data": _vm.audienceFollowersGender
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body text-center"
  }, [_c('div', [_c('bar-chart-js', {
    attrs: {
      "name": "audBarChart",
      "chartData": _vm.audienceReachabilityData,
      "options": _vm.audChartOptions
    }
  })], 1)])])])], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.audience_followers.success) ? _c('v-row', [(_vm.audienceFollowers.audience_geo && _vm.audienceFollowers.audience_geo.countries.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title text-center"
  }, [_vm._v("Location by Country")]), _vm._v(" "), _vm._l((_vm.audienceFollowers.audience_geo.countries.slice(0, 3)), function(country) {
    return _c('div', {
      key: country.code
    }, [_c('h5', {
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v("\n                      " + _vm._s(country.name) + "\n                      "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s((country.weight * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('b-progress', {
      staticClass: "mb-4",
      attrs: {
        "value": country.weight * 100,
        "max": 100,
        "precision": 2
      }
    })], 1)
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.audienceFollowers.audience_ethnicities.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title text-center"
  }, [_vm._v("Ethnicity")]), _vm._v(" "), _vm._l((_vm.audienceFollowers.audience_ethnicities.slice(0, 5)), function(item) {
    return _c('div', {
      key: item.code
    }, [_c('h5', [_vm._v("\n                      " + _vm._s(item.name) + "\n                      "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s((item.weight * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('b-progress', {
      staticClass: "mb-4",
      attrs: {
        "show-progress": "",
        "animated": "",
        "value": item.weight * 100,
        "max": 100,
        "precision": 2
      }
    })], 1)
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.audienceFollowers.audience_languages.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title text-center"
  }, [_vm._v("Language")]), _vm._v(" "), _vm._l((_vm.audienceFollowers.audience_languages.slice(0, 5)), function(item) {
    return _c('div', {
      key: item.code
    }, [_c('h5', [_vm._v("\n                      " + _vm._s(item.name) + "\n                      "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s((item.weight * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('b-progress', {
      staticClass: "mb-4",
      attrs: {
        "value": item.weight * 100,
        "max": 100,
        "precision": 2
      }
    })], 1)
  })], 2)])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.influencer.audience_followers.success) ? _c('v-row', [(_vm.audienceFollowers.audience_brand_affinity.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title text-center"
  }, [_vm._v("Audience Brand Affinity")]), _vm._v(" "), _vm._l((_vm.audienceFollowers.audience_brand_affinity.slice(0, 5)), function(item) {
    return _c('div', {
      key: item.name
    }, [_c('h5', [_vm._v("\n                      " + _vm._s(item.name) + "\n                      "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s((item.weight * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('b-progress', {
      staticClass: "mb-4",
      attrs: {
        "value": item.weight * 100,
        "max": 100,
        "precision": 2
      }
    })], 1)
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.audienceFollowers.audience_interests.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title text-center"
  }, [_vm._v("Audience Interests")]), _vm._v(" "), _vm._l((_vm.audienceFollowers.audience_interests.slice(0, 5)), function(item) {
    return _c('div', {
      key: item.name
    }, [_c('h5', [_vm._v("\n                      " + _vm._s(item.name) + "\n                      "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s((item.weight * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('b-progress', {
      staticClass: "mb-4",
      attrs: {
        "show-progress": "",
        "animated": "",
        "value": item.weight * 100,
        "max": 100,
        "precision": 2
      }
    })], 1)
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.audienceFollowers.notable_users.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title text-center"
  }, [_vm._v("Notable Followers")]), _vm._v(" "), _c('ul', {
    staticClass: "products-list product-list-in-box"
  }, _vm._l((_vm.audienceFollowers.notable_users.slice(0, 4)), function(item) {
    return _c('li', {
      key: item.username,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "product-img"
    }, [_c('img', {
      attrs: {
        "src": _vm.paserImageUrl(item.picture),
        "alt": "Avatar"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "product-info"
    }, [_c('a', {
      staticClass: "product-title",
      attrs: {
        "href": item.url,
        "target": "_blank"
      }
    }, [_vm._v("@" + _vm._s(item.username))]), _vm._v(" "), _c('span', {
      staticClass: "product-description"
    }, [_vm._v(_vm._s(item.fullname))])])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.audienceFollowers.audience_geo && _vm.audienceFollowers.audience_geo.countries.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title text-center"
  }, [_vm._v("Location by Country")]), _vm._v(" "), _c('div', [_c('v-simple-table', {
    staticClass: "aud-location-table no-border",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Country")]), _vm._v(" "), _c('th', {
          staticClass: "text-right"
        }, [_vm._v("Followers")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.audienceFollowers.audience_geo.countries), function(country) {
          return _c('tr', {
            key: country.code
          }, [_c('td', {
            staticClass: "text-left pl-0"
          }, [_c('h5', {
            staticStyle: {
              "font-weight": "600"
            }
          }, [_vm._v("\n                                " + _vm._s(country.name) + "\n                              ")])]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('span', {
            staticStyle: {
              "float": "right"
            }
          }, [_vm._v(_vm._s((country.weight * 100).toFixed(2)) + "%")])])])
        }), 0)]
      },
      proxy: true
    }], null, false, 437158719)
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.audienceFollowers.audience_interests && _vm.audienceFollowers.audience_interests.length > 0) ? _c('v-col', {
    attrs: {
      "xs": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title text-center"
  }, [_vm._v("Audience Interest Affinity")]), _vm._v(" "), _c('div', [_c('v-simple-table', {
    staticClass: "aud-location-table no-border",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function() {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v("Interest")]), _vm._v(" "), _c('th', {
          staticClass: "text-right"
        }, [_vm._v("Followers")]), _vm._v(" "), _c('th', {
          staticClass: "text-right"
        }, [_vm._v("Followers affinity")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.audienceFollowers.audience_interests.slice(0, 15)), function(brand) {
          return _c('tr', {
            key: brand.code
          }, [_c('td', {
            staticClass: "text-left pl-0"
          }, [_c('h5', {
            staticStyle: {
              "font-weight": "600"
            }
          }, [_vm._v("\n                                " + _vm._s(brand.name) + "\n                              ")])]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('span', {
            staticStyle: {
              "float": "right"
            }
          }, [_vm._v(_vm._s((brand.weight * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('span', {
            staticStyle: {
              "float": "right"
            }
          }, [_vm._v(_vm._s((brand.affinity * 100).toFixed(2)) + "%")])])])
        }), 0)]
      },
      proxy: true
    }], null, false, 3036307875)
  })], 1)])])]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('v-btn', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25728b9c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/AudienceDataReportModal.vue
// module id = 2042
// module chunks = 0